import { EVENT_PRODUCT_TYPE_E } from "./alerts.types";
import { IResponsePagination } from "./pagination.types";

export interface IGetDevicesConfigurationsRequestData {
	page: number;
	search?: string;
}

export interface IDeviceMLSettingsDetails {
	radar_info: {
		host: string;
		port: number;
		enable: boolean;
		y_range: number[];
	};
	relay_setting: number;
	allow_unauth_exit: boolean;
	draw_vehicle_bbox: boolean;
	manager_webhook_url: string;
	show_lc_counts_rtmp: boolean;
	draw_number_plate_bbox: boolean;
	enable_manager_webhook: boolean;
	show_processing_fps_rtmp: boolean;
	enable_auth_plate_mathching: boolean;
	manager_webhook_attach_frame: boolean;
	manager_webhook_attach_plate: boolean;
	auth_plate_matching_threshold: number;
	manager_webhook_custom_header: {};
	manager_webhook_send_single_event: boolean;
}

export interface IDeviceHealthData {
	device_data: {
		detail: [
			{
				device_uptime: {
					Days: number;
					Hours: number;
					Minutes: number;
					Seconds: number;
				};
			},
			{
				GPU: [number, number];
				Thermal: [number, number];
			},
			{
				Ram: [number, number];
				Swap: [number, number];
				Device: [number, number];
				External: [number, number];
			}
		];
		status: string;
		message: string[];
	};
	docker_data: {
		detail: {
			[key in string]: [string, string, string];
		};
		status: string;
		message: string[];
	};
}

export interface IDeviceConfigurationDetails {
	id: number;
	device_name: string;
	username: string;
	drop_frame: number;
	batch_timeout: number;
	barrier_uptime: number;
	device_uuid: string;
	release_version: string;
	local_ipv4_address: string;
	global_ipv4_address: string;
	mode: number;
	device_type: string;
	light_activation_time: number;
	barrier_config: number;
	si_id: number | null;
	blob_base_url: string | null;
	plate_img_base_url: string | null;
	frame_img_base_url: string | null;
	camera_img_base_url: string | null;
	product_name: string;
	camera_mode: number;
	filter_unreadable_plate_events: boolean;
	overspeeding_limit_kmph: number;
	overspeeding_alert_email: string | null;
	ml_settings: IDeviceMLSettingsDetails;
	product_type: number;
	device_status: "Online" | "Offline";
	health_data: IDeviceHealthData;
	mount_status: boolean;
	customer: null;
	jurisdiction: number;
}

export type IGetDevicesConfigurationsResponseData = IResponsePagination<IDeviceConfigurationDetails>;

export interface IGetDeviceCamerasListRequestData {
	page: number;
	device: number;
}

export interface IDeviceCameraROIDetails {
	id: number;
	camera_roi_uuid: string;
	name: string;
	line: string;
	roi: string;
	num_lines: number;
	camera_id: number;
	enable_speed_analytics: boolean;
	starting_line: [number, number, number, number];
	ending_line: [number, number, number, number];
	path_length: number;
	path_width: number;
	radar_speed_display_config: {
		lane_range: number[];
		speed_display: {
			host: string;
			port: number;
			enable: boolean;
			display_secs: number;
		};
	};
}

export interface IDeviceCameraDetails {
	id: number;
	camera_config_roi: IDeviceCameraROIDetails[];
	camera_uuid: string;
	rtsp_uri: string;
	site_name: string;
	rtmp_uri: string | null;
	roi: string;
	line: string;
	zoom: number | null;
	is_entry: boolean;
	width: number;
	height: number;
	num_lines: number;
	site_id: string;
	camera_id: string;
	latest_camera_snapshot: string | null;
	camera_page_url: string | null;
	secondary_stream_rtsp_uri: string | null;
	is_camera_snapshot_synced: boolean;
	device: number;
	customer: null;
}

export type IGetDeviceCamerasListResponseData = IResponsePagination<IDeviceCameraDetails>;

export enum INTERCEPTOR_STATUS_E {
	UNKNOWN = 0,
	ONLINE = 2,
	OFFLINE = 1
}

export interface IInterceptorDetails {
	id: number;
	device_data: IDeviceConfigurationDetails | null;
	uuid: string;
	numberplate: string;
	location_cord_latitude: string;
	location_cord_longitude: string;
	location_name: string | null;
	is_active: INTERCEPTOR_STATUS_E;
	device: number;
	customer: number | null;
}

export type IGetInterceptorsListResponseData = IResponsePagination<IInterceptorDetails>;

export interface IGetInterceptorsListRequestData {
	page: number;
	search?: string;
	all?: boolean;
}

export interface ICreateInterceptorRequestData {
	uuid: string;
	numberplate: string;
	device?: number;
	location_cord_latitude?: number;
	location_cord_longitude?: number;
	location_name?: string;
}

export interface IEditInterceptorRequestData {
	id: number;
	data: {
		uuid?: string;
		numberplate?: string;
		device?: number;
		location_cord_latitude?: number;
		location_cord_longitude?: number;
		location_name?: string;
	};
}

export interface ICreateDeviceRequestData {
	device_name: string;
	username: string;
	device_uuid: string;
	product_name: string;
	filter_unreadable_plate_events: false;
	product_type: EVENT_PRODUCT_TYPE_E;
	customer: 1;
	device_status: "Onboard";
	local_ipv4_address: string;
	global_ipv4_address: string;
	release_version: string;
}

export interface IContactUsRequestData {
	name: string;
	email: string;
	message: string;
}
